import { useRef } from "react";
import React from "react";

import mergeRefs from "merge-refs";

import { RadioInputStyle } from "./styles";

export type RadioInputProps<T extends string> = {
  name: string;
  id: string;
  value: T;
  checked?: boolean | null;
  onChangeValue?: (value: T) => void;
  hasError?: boolean;
} & Omit<
  React.HTMLProps<HTMLInputElement>,
  "value" | "name" | "color" | "id" | "checked" | "ref" | "label"
>;

export const _RadioInput = (
  {
    onChange,
    onChangeValue,
    className,
    style,
    hasError,
    disabled,
    ...props
  }: RadioInputProps<string>,
  ref?: React.ForwardedRef<HTMLInputElement>
) => {
  const inputRef = useRef<HTMLInputElement>();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event);
    onChangeValue?.(event.target.value);
  };

  return (
    <RadioInputStyle disabled={disabled} hasError={hasError} className={className} style={style}>
      <RadioInputStyle.Input
        disabled={disabled}
        ref={mergeRefs(inputRef, ref)}
        type="radio"
        onChange={handleChange}
        {...props}
      />
    </RadioInputStyle>
  );
};

// TODO: remove once React19 is here
export const RadioInput = React.forwardRef(_RadioInput) as <T extends string>(
  props: RadioInputProps<T> & {
    ref?: React.ForwardedRef<HTMLInputElement>;
  }
) => ReturnType<typeof _RadioInput>;
